import script from "./dashbExpr.vue?vue&type=script&setup=true&lang=js"
export * from "./dashbExpr.vue?vue&type=script&setup=true&lang=js"

import "./dashbExpr.vue?vue&type=style&index=0&id=5abc8df3&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5abc8df3"]])

export default __exports__